import { get } from 'lodash-es';

import { isBlank } from './helpers';
import { snakeCaseKeys } from './object';

function mapPmpData(form: any) {
  let pmpData = get(form, 'pmpData');
  if (pmpData) {
    const dealBidFloor = get(form, 'pmpData.dealBidFloor', 0);
    pmpData = {
      ...snakeCaseKeys(form.pmpData),
      creative_type: String(form.pmpData.creativeType),
      deal_bid_floor: parseInt((dealBidFloor * 100).toFixed(2), 10),
    };
  }
  return pmpData;
}

export default function mapFormToAdGroup(form: any): any {
  const pmpData = mapPmpData(form);

  return {
    ...snakeCaseKeys({
      ...form,
      // Do not include isExcludedLocationsFormDirty in the payload as it is only used for form validation and not needed in the API request
      isExcludedLocationsFormDirty: undefined,
    }),
    targetings_enabled: {
      ...form.targetingsEnabled,
      needs_tn_user_id: undefined,
      // Deprecated CTR/VCR tiers: force-disable so ventura zeroes any stored tier values on save.
      app_whitelist_tier: false,
      app_blacklist_threshold: false,
      app_vcr_whitelist_tier: false,
      app_vcr_blacklist_threshold: false,
    },
    targeting_profile: {
      ...form.targetingProfile,
      needs_tn_user_id: form.targetingsEnabled?.needs_tn_user_id && form.targetingProfile?.needs_tn_user_id,
      location_fetch_enabled:
        form.targetingsEnabled?.location_fetch_enabled && form.targetingProfile?.location_fetch_enabled,
      dv_ivt_prebid_filter: form.targetingsEnabled?.dv_ivt_prebid_filter && form.targetingProfile?.dv_ivt_prebid_filter,
      dv_custom_segment_inclusion: form.targetingsEnabled?.dv_custom_segment_inclusion
        ? form.targetingProfile?.dv_custom_segment_inclusion || []
        : [],
      dv_custom_segment_exclusion: form.targetingsEnabled?.dv_custom_segment_exclusion
        ? form.targetingProfile?.dv_custom_segment_exclusion || []
        : [],
    },
    max_bid: parseInt((form.maxBid * 100).toFixed(2), 10),
    spend_percent: isBlank(form.spendPercent) ? null : Number(form.spendPercent),
    campaign_urls: form.campaignUrls?.map((campaignUrl) => campaignUrl.value),
    pixel_urls: form.pixelUrls?.map((pixelUrl) => pixelUrl.value),
    pmp_data: pmpData,
  };
}
